import React, { useState } from 'react';
import Compiler from '@shared/compiler';
import { CODING_LANGUAGE, LANG_MAP, LANG_OPTION } from '@lib/constants';
import axios from 'axios';
import { getBytesStrapiUrl } from '@lib/bytesStrapiServices';
import MarkDownPreview from '@components/reuseable/MarkDownPreview';
import SiteHeader from '@components/shared/SiteHeader';
import { getImgUrl } from '@utils/functions/getImgUrl';

function Playground({ language, langData }) {
  const [lang, setLang] = useState(language);

  const { metaTitle, metaDescription, metaRobots, metaImage, canonicalURL, structuredData } =
    langData?.seo || {};

  return (
    <>
      <SiteHeader
        title={metaTitle}
        desc={metaDescription}
        metaRobots={metaRobots}
        image={getImgUrl(metaImage)}
        canonicalUrl={canonicalURL}
        structuredData={structuredData}
      />
      <div className="[&>*]:mb-20">
        <div className="mx-8 !mb-4 md:mx-14">
          <h1 className="font-satoshi-bold text-2xl">{langData?.title}</h1>
        </div>
        <Compiler selectedLang={lang} setLang={setLang} />
        <div className="mx-8 md:mx-14">
          <div className="font-satoshi-medium">
            <MarkDownPreview content={langData?.description} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Playground;

export const getStaticProps = async ({ params }) => {
  try {
    const { lang } = params;

    const listOfCodingLanguage = CODING_LANGUAGE;

    const bytesAPIBaseURL = getBytesStrapiUrl();

    const inputLang = lang?.toLowerCase();

    if (!listOfCodingLanguage.includes(inputLang)) {
      return {
        notFound: true,
      };
    }

    const {
      data: { data },
    } = await axios.get(
      `${bytesAPIBaseURL}/api/compilers?populate=*,seo.metaImage&filters[$and][0][language][$eq]=${LANG_OPTION[inputLang]}`
    );

    if (data?.length === 0) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        language: inputLang,
        langData: data?.[0]?.attributes || null,
      },
      revalidate: 3600,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

export async function getStaticPaths() {
  const bytesAPIBaseURL = getBytesStrapiUrl();

  const {
    data: { data },
  } = await axios.get(`${bytesAPIBaseURL}/api/compilers`);

  const paths = data?.map(({ attributes }) => ({
    params: { lang: LANG_MAP[attributes.language] },
  }));

  return { paths, fallback: 'blocking' };
}
